// extracted by mini-css-extract-plugin
export default {"approveHubDelete":"ApproveDeletedHubs_approveHubDelete__xGxmc"};